module.exports = __webpack_public_path__ + "img/zengsong.06aae25b.png";